<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/video-main-banner.svg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("performance-board") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="sl_list sa_performance_board">
      <div class="col-xl-12 col-md-12 pa-0">
        <v-tabs
          v-model="categoryTab"
          align-with-title
          touchless
          class="col-md-9 col-xl-9 pb-0 LanguageselectTabgroup sales-list-wrap pt-md-4 pt-lg-0 p-0"
        >
          <v-tabs-slider color="indigo"></v-tabs-slider>

          <v-tab class="LanguageselectTab sales-tabbing">
            {{ $t("revenue") }}
          </v-tab>
          <v-tab class="LanguageselectTab sales-tabbing">
            {{ $t("trainer_productivity") }}
          </v-tab>
          <v-tab class="LanguageselectTab sales-tabbing">
            {{ $t("room_usage") }}
          </v-tab>
          <v-tab class="LanguageselectTab sales-tabbing">
            {{ $t("feedback_evaluation") }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="categoryTab" touchless>
          <v-tab-item>
            <div class="saleslist_body">
              <div class="revenue-tabbing-wrapper">
                <div
                  class="saleslist_header row m-0 revenue-saleslist-header"
                  v-if="istabrevenuedropdown == 1"
                >
                  <div
                    class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1"
                  >
                    <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                      <v-autocomplete
                        v-model="yearFilterRevenue"
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        :items="yearsList"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('select_year')"
                        @change="changeYearRevenue()"
                      >
                        <template v-slot:append></template>
                      </v-autocomplete>
                    </div>
                    <div class="col-md-12 col-xl-4 p-0 revanue_vtv">
                      <v-btn
                        v-show="
                          $rights.includes('VIEW_TARGET_REVENUE') && actualChart
                        "
                        :to="`/list-target-revenue`"
                        outlined
                        depressed
                        tile
                        class="savebutton"
                        style=""
                      >
                        {{ $t("view_target_value") }}</v-btn
                      >
                    </div>
                  </div>
                  <div
                    class="col-md-12 col-xl-6 g-space-15 revanue_wrap2 d-flex justify-content-end align-self-center actual-revenew-filter-wrapper"
                  >
                    <div class="col-md-12 col-xl-3 p-0 revanue_fbc">
                      <v-autocomplete
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center"
                        dense
                        outlined
                        :label="$t('filter_by_country')"
                        v-model="actualcountry"
                        :items="sortedCountries"
                        @change="changeActualCountry()"
                      >
                        <template v-slot:append></template>
                      </v-autocomplete>
                    </div>
                    <v-btn
                      v-if="
                        $rights.includes('VIEW_PERFORMANCE_BOARD') &&
                        !actualChart
                      "
                      @click="changeRevenueChart()"
                      outlined
                      depressed
                      tile
                      class="savebutton revanue_vc"
                      style="display: flex"
                      ><img class="" src="../assets/img/chart.svg" />
                      {{ $t("view_charts") }}</v-btn
                    >
                    <v-btn
                      @click="changeRevenueChart()"
                      v-if="
                        $rights.includes('VIEW_PERFORMANCE_BOARD') &&
                        actualChart
                      "
                      outlined
                      depressed
                      tile
                      class="savebutton revanue_vr view-reports-ac-revenue test"
                      ><img src="/static/img/report.svg" />{{
                        $t("view_reports")
                      }}
                    </v-btn>
                  </div>
                </div>
                <div
                  class="saleslist_header row m-0 revenue-saleslist-header"
                  v-if="istabrevenuedropdown == 2"
                >
                  <div
                    class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap"
                  >
                    <div class="col-md-12 col-xl-2 p-0 revanue_sy">
                      <v-autocomplete
                        v-model="yearOpenTrasactionsstart"
                        hide-details="auto"
                        class="select-start-year-input datainput justify-content-end align-self-center pb-1"
                        :items="yearsOpenTransactions"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('select_start_year')"
                        @change="getOpenTransactions()"
                      ></v-autocomplete>
                    </div>
                    <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                      <v-autocomplete
                        v-model="monthOpenTrasactionsstart"
                        hide-details="auto"
                        class="select-start-year-input datainput justify-content-end align-self-center pb-1"
                        :items="months"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('select_start_month')"
                        @change="getOpenTransactions()"
                      ></v-autocomplete>
                    </div>
                    <div class="col-md-12 col-xl-2 p-0 revanue_sy">
                      <v-autocomplete
                        v-model="yearOpenTrasactionsend"
                        hide-details="auto"
                        class="select-start-year-input datainput justify-content-end align-self-center pb-1"
                        :items="yearsOpenTransactions"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('select_end_year')"
                        @change="getOpenTransactions()"
                      ></v-autocomplete>
                    </div>
                    <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                      <v-autocomplete
                        v-model="monthOpenTrasactionsend"
                        hide-details="auto"
                        class="select-start-year-input datainput justify-content-end align-self-center pb-1"
                        :items="months"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('select_end_month')"
                        @change="getOpenTransactions()"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div
                    class="col-md-12 col-xl-6 d-flex g-space-15 justify-content-end align-self-center"
                  >
                    <div class="col-md-12 col-xl-3 p-0 revanue_fbc">
                      <v-autocomplete
                        hide-details="auto"
                        class="v-input datainput justify-content-end align-self-center v-input--hide-details v-input--is-label-active v-input--is-dirty v-input--is-focused v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select v-autocomplete primary--text"
                        dense
                        outlined
                        :label="$t('filter_by_country')"
                        :items="sortedCountries"
                        @change="changeOpenCountry()"
                        v-model="opencountry"
                      >
                        <template v-slot:append></template>
                      </v-autocomplete>
                    </div>
                    <v-btn
                      v-if="
                        $rights.includes('VIEW_PERFORMANCE_BOARD') && !openChart
                      "
                      @click="changeOpenChart()"
                      outlined
                      depressed
                      tile
                      class="view-chart-open-transaction savebutton"
                      style="display: flex"
                      ><img
                        class="view-charts-img"
                        src="../assets/img/chart.svg"
                      />
                      {{ $t("view_charts") }}</v-btn
                    >

                    <v-btn
                      v-if="
                        $rights.includes('VIEW_PERFORMANCE_BOARD') && openChart
                      "
                      @click="changeOpenChart()"
                      outlined
                      depressed
                      tile
                      class="view-resort-open-transaction savebutton"
                      style="display: flex"
                      ><img
                        class="view-reports-img"
                        src="../assets/img/view-report.svg"
                      />
                      {{ $t("view_reports") }}</v-btn
                    >
                  </div>
                </div>
                <b-tabs content-class="mt-0 feedback_main_wrapper">
                  <b-tab
                    class="feedback_actual_revenue feedback_actual_revenue_lg"
                    active
                    @click="istabrevenue(1)"
                  >
                    <template #title>
                      <h3 class="open-actual-head">
                        {{ $t("actual_revenue") }}
                      </h3>
                    </template>
                    <div
                      class="tab_inner_header d-flex actual-revenue-header"
                    ></div>
                    <div
                      class="tab_inner_body"
                      v-if="!actualChart && itemsActualTable.length > 0"
                    >
                      <b-table
                        responsive
                        striped
                        hover
                        :items="itemsActualTable"
                        :fields="itemsActual"
                        class="actual_forecast_table"
                      >
                        <template #cell(index)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ $t("forecast") }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ $t("actual") }}
                          </div>
                          <div
                            v-if="data.item.month == $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ $t("SUM") }}
                          </div>
                        </template>

                        <template #cell(rsgi)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetrsgi }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.rsgi }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.rsgi }}
                          </div>
                        </template>

                        <template #cell(mainline)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetMainline }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.mainline }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.mainline }}
                          </div>
                        </template>

                        <template #cell(db)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetDb }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.db }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.db }}
                          </div>
                        </template>

                        <template #cell(urban)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetUrban }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.urban }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.urban }}
                          </div>
                        </template>

                        <template #cell(p)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetP }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.p }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.p }}
                          </div>
                        </template>

                        <template #cell(ic)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetIc }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.ic }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.ic }}
                          </div>
                        </template>

                        <template #cell(pic)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetPic }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.pic }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.pic }}
                          </div>
                        </template>

                        <template #cell(oe)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetOe }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.oe }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.oe }}
                          </div>
                        </template>

                        <template #cell(lv)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetLv }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.lv }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.lv }}
                          </div>
                        </template>

                        <template #cell(oeiv)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetOeiv }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.oeiv }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.oeiv }}
                          </div>
                        </template>

                        <template #cell(total)="data">
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-target"
                          >
                            {{ data.item.targetTotal }}
                          </div>
                          <div
                            v-if="data.item.month !== $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.total }}
                          </div>
                          <div
                            v-if="data.item.month === $t('SUM')"
                            class="text-info-actual"
                          >
                            {{ data.item.total }}
                          </div>
                        </template>
                      </b-table>
                    </div>
                    <div
                      class="tab_inner_body import-text"
                      v-if="itemsActualTable.length == 0"
                    >
                      <div class="actual_revenue_description">
                        {{ $t("actual_revenue_description") }}
                      </div>
                    </div>
                    <div class="cl_chart_wrap">
                      <div class="row average-wrapper" v-if="actualChart">
                        <div
                          id="urban"
                          class="average-grade border border-dark border-5"
                        >
                          <b>{{ $t("totalrevenue") }}{{ yearFilterRevenue }}</b>
                          <BarChartKB
                            :chart-labels="roomusagelabels"
                            :chart-datasets="revenueactualtarget"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsTotalrevenue"
                          />
                        </div>
                        <div
                          id="urban"
                          class="average-grade border border-dark border-5"
                        >
                          <b
                            >{{ $t("totalactualrevenue")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="roomusagelabels"
                            :chart-datasets="revenueactualtargetTotal"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsTotalactualrevenue"
                          />
                        </div>
                        <div class="average-grade border border-dark border-5">
                          <b
                            >{{ $t("realised_revenue_3p")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenue3Pdatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptions3p"
                          />
                        </div>
                        <div class="average-grade border border-dark border-5">
                          <b
                            >{{ $t("realised_revenue_IC")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenueICdatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsIC"
                          />
                        </div>
                        <div class="average-grade border border-dark border-5">
                          <b
                            >{{ $t("realised_revenue_OE")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenueOEdatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsOE"
                          />
                        </div>
                        <div class="average-grade border border-dark border-5">
                          <b
                            >{{ $t("realised_revenue_IV")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenueIVdatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsIV"
                          />
                        </div>
                        <div
                          class="average-grade border border-dark border-5"
                          v-show="
                            actualcountry == 'GERMANY' || actualcountry == 'All'
                          "
                        >
                          <b
                            >{{ $t("realised_revenue_rsgi")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenuersgidatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsRSGI"
                          />
                        </div>
                        <div
                          class="average-grade border border-dark border-5"
                          v-show="
                            actualcountry == 'GERMANY' || actualcountry == 'All'
                          "
                        >
                          <b
                            >{{ $t("realised_revenue_mainline")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenuemainlinedatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsMainline"
                          />
                        </div>
                        <div
                          class="average-grade border border-dark border-5"
                          v-show="
                            actualcountry == 'GERMANY' || actualcountry == 'All'
                          "
                        >
                          <b
                            >{{ $t("realised_revenue_db")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenuedbdatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsDB"
                          />
                        </div>
                        <div
                          id="urban"
                          class="average-grade border border-dark border-5"
                          v-show="
                            actualcountry == 'GERMANY' || actualcountry == 'All'
                          "
                        >
                          <b
                            >{{ $t("realised_revenue_urban")
                            }}{{ yearFilterRevenue }}</b
                          >
                          <BarChartKB
                            :chart-labels="monthlabels"
                            :chart-datasets="actualrevenueurbandatasets"
                            :chart-id="roomusagechartId"
                            :dataset-id-key="roomusagedatasetIdKey"
                            :plugins="roomusageplugins"
                            :css-classes="roomusagecssClasses"
                            :styles="roomusagestyles"
                            :width="roomusagewidth"
                            :height="roomusageheight"
                            :chartOptions="chartOptionsUrban"
                          />
                        </div>
                      </div>
                      <div class="row average-wrapper" v-if="actualChart"></div>
                    </div>
                  </b-tab>
                  <b-tab title="|" disabled></b-tab>
                  <b-tab
                    class="feedback_open_transaction"
                    @click="istabrevenue(2)"
                  >
                    <template #title>
                      <h3 class="open-actual-head">
                        {{ $t("open_transaction") }}
                      </h3>
                    </template>
                    <div class="tab_inner_header">
                      <div
                        class="tab_inner_body"
                        v-if="!openChart && itemsOpenTable.length > 0"
                      >
                        <b-table
                          responsive
                          striped
                          hover
                          :fields="itemsOpen"
                          :items="itemsOpenTable"
                        >
                        </b-table>
                      </div>
                      <div
                        class="tab_inner_body import-text"
                        v-if="itemsOpenTable.length == 0"
                      >
                        <p class="actual_revenue_description">
                          {{ $t("Open_Transaction_description") }}
                        </p>
                      </div>
                      <div>
                        <div class="row average-wrapper" v-if="openChart">
                          <div
                            class="col-6 border border-dark border-5 average-grade"
                          >
                            <b
                              >{{ $t("current_training_operations")
                              }}{{
                                yearOpenTrasactionsstart +
                                " - " +
                                yearOpenTrasactionsend
                              }}</b
                            >
                            <BarChartKB
                              :chart-labels="currentTrainingOperationslabels"
                              :chart-datasets="
                                currentTrainingOperationsdatasets
                              "
                              :chart-id="roomusagechartId"
                              :dataset-id-key="roomusagedatasetIdKey"
                              :plugins="roomusageplugins"
                              :css-classes="roomusagecssClasses"
                              :styles="roomusagestyles"
                              :width="roomusagewidth"
                              :height="roomusageheight"
                              :chartOptions="chartOptionsCurrent"
                            />
                          </div>
                          <div
                            class="col-6 border border-dark border-5 average-grade"
                          >
                            <b
                              >{{ $t("request_comparisons")
                              }}{{
                                getMonthNameById(monthOpenTrasactionsstart) +
                                " " +
                                yearOpenTrasactionsstart +
                                " - "
                              }}{{
                                getMonthNameById(monthOpenTrasactionsend) +
                                " " +
                                yearOpenTrasactionsend
                              }}</b
                            >
                            <BarChartKB
                              :chart-labels="requestComparisonlabels"
                              :chart-datasets="requestComparisondatasets"
                              :chart-id="roomusagechartId"
                              :dataset-id-key="roomusagedatasetIdKey"
                              :plugins="roomusageplugins"
                              :css-classes="roomusagecssClasses"
                              :styles="roomusagestyles"
                              :width="roomusagewidth"
                              :height="roomusageheight"
                              :chartOptions="chartOptionsComparision"
                            />
                          </div>
                          <div
                            class="col-6 border border-dark border-5 average-grade"
                          >
                            <b
                              >{{ $t("classification_by_customer")
                              }}{{
                                yearOpenTrasactionsstart +
                                " - " +
                                yearOpenTrasactionsend
                              }}</b
                            >
                            <BarChartKB
                              :chart-labels="classificationByCustomerlabels"
                              :chart-datasets="classificationByCustomerdatasets"
                              :chart-id="roomusagechartId"
                              :dataset-id-key="roomusagedatasetIdKey"
                              :plugins="roomusageplugins"
                              :css-classes="roomusagecssClasses"
                              :styles="roomusagestyles"
                              :width="roomusagewidth"
                              :height="roomusageheight"
                              :chartOptions="chartOptionsByCustomer"
                            />
                          </div>
                          <div
                            class="col-6 border border-dark border-5 average-grade"
                          >
                            <b
                              >{{ $t("change_in_total_operations")
                              }}{{
                                getMonthNameById(monthOpenTrasactionsstart) +
                                " " +
                                yearOpenTrasactionsstart +
                                " - "
                              }}{{
                                getMonthNameById(monthOpenTrasactionsend) +
                                " " +
                                yearOpenTrasactionsend
                              }}</b
                            >
                            <BarChartKB
                              :chart-labels="changeInTotalOperationslabels"
                              :chart-datasets="changeInTotalOperationsdatasets"
                              :chart-id="roomusagechartId"
                              :dataset-id-key="roomusagedatasetIdKey"
                              :plugins="roomusageplugins"
                              :css-classes="roomusagecssClasses"
                              :styles="roomusagestyles"
                              :width="roomusagewidth"
                              :height="roomusageheight"
                              :chartOptions="chartOptionsTotalOperation"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="saleslist_header row m-0 revenue-saleslist-header">
              <div class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1">
                <div class="col-md-12 col-xl-3 p-0 revanue_sy mb__20">
                  <v-autocomplete
                    v-model="yearTrainerProductivity"
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    :items="yearsListRoom"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    :label="$t('select_year')"
                    @change="getTrainerProductivity()"
                  ></v-autocomplete>
                </div>
                <div class="col-md-12 col-xl-3 p-0 revanue_fbc">
                  <v-autocomplete
                    hide-details="auto"
                    :items="sortedCountries"
                    class="datainput justify-content-end align-self-center pb-1 country-wrap-dropdown-1"
                    dense
                    outlined
                    :label="$t('country')"
                    v-model="feedbackcountry"
                    @change="changeCountrytrainerProductivity()"
                  ></v-autocomplete>
                </div>
              </div>
              <div class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1">
                <div class="trainer-productivity-wrap p-0">
                  <v-btn
                    v-if="
                      $rights.includes('VIEW_PERFORMANCE_BOARD') && !openChart
                    "
                    @click="changeOpenChart()"
                    outlined
                    depressed
                    tile
                    class="view-chart-open-transaction savebutton"
                    style="display: flex"
                    ><img
                      class="view-charts-img"
                      src="../assets/img/chart.svg"
                    />
                    {{ $t("view_charts") }}</v-btn
                  >

                  <v-btn
                    v-if="
                      $rights.includes('VIEW_PERFORMANCE_BOARD') && openChart
                    "
                    @click="changeOpenChart()"
                    outlined
                    depressed
                    tile
                    class="view-resort-open-transaction savebutton"
                    style="display: flex"
                    ><img
                      class="view-reports-img"
                      src="../assets/img/view-report.svg"
                    />
                    {{ $t("view_reports") }}</v-btn
                  >
                </div>
              </div>
            </div>
            <div
              v-if="!openChart"
              class="saleslist_body saleslist_body-trainer trainer-table col-md-12"
            >
              <div>
                <div>
                  <h2 class="apt-table-head">
                    {{ $t("trainer_Productivity") }}
                    {{ yearTrainerProductivity }}
                  </h2>
                  <div class="scroll-h-wrapper">
                    <table class="appointments-table apt-table">
                      <thead>
                        <tr>
                          <th v-for="month in trainerproductivity" :key="month">
                            {{ getMonthName(month.month) }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            v-for="(data, index) in trainerproductivity"
                            :key="index"
                          >
                            <b>{{ data.totalProductive }}%</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  v-for="monthData in trainerproductivity"
                  :key="monthData.month"
                  class="month-table"
                >
                  <h2>
                    {{
                      getMonthName(monthData.month) +
                      "  " +
                      yearTrainerProductivity
                    }}
                  </h2>
                  <div class="scroll-h-wrapper">
                    <table class="appointments-table">
                      <thead>
                        <tr>
                          <th>{{ $t("trainer_name") }}</th>
                          <th>{{ $t("working_Days") }}</th>
                          <th>{{ $t("vacation") }}</th>
                          <th>{{ $t("real_Working") }}</th>
                          <th>{{ $t("sick") }}</th>
                          <th>{{ $t("pre/Post_Preparation") }}</th>
                          <th>{{ $t("training_trainer_productivity") }}</th>
                          <th>{{ $t("further_Training") }}</th>
                          <th>
                            {{ $t("appointment_type_training_initiative") }}
                          </th>
                          <th>{{ $t("appointment_type_travel_time") }}</th>
                          <th>{{ $t("misc") }}</th>
                          <th>{{ $t("productivity") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="trainer in monthData.trainerProductivity"
                          :key="monthData.month + trainer.trainername"
                        >
                          <td>{{ trainer.trainername }}</td>
                          <td>{{ trainer.workingdays }}</td>
                          <td>{{ trainer.vacation }}</td>
                          <td>{{ trainer.realworking }}</td>
                          <td>
                            <div class="qn_add">
                              <v-icon
                                :disabled="trainer.sick == 0"
                                @click="decrease(trainer)"
                                >mdi-minus</v-icon
                              >
                              <p>{{ trainer.sick }}</p>
                              <v-icon
                                :disabled="trainer.vacation == 0"
                                @click="increase(trainer)"
                                >mdi-plus</v-icon
                              >
                            </div>
                          </td>
                          <td>{{ trainer.prepostpreparation }}</td>
                          <td>{{ trainer.training }}</td>
                          <td>{{ trainer.furthertraining }}</td>
                          <td>{{ trainer.traininginitiative }}</td>
                          <td>{{ trainer.traveltime }}</td>
                          <td>{{ trainer.misc }}</td>
                          <td>{{ trainer.productivity }}%</td>
                        </tr>
                        <tr class="md_tp">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{{ monthData.totalProductive }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br />
                  <div class="scroll-h-wrapper">
                    <table class="appointments-table single_trainer">
                      <tbody>
                        <tr v-if="monthData.norbertproductivity">
                          <td>
                            {{ monthData.norbertproductivity.trainername }}
                          </td>
                          <td>
                            {{ monthData.norbertproductivity.workingdays }}
                          </td>
                          <td>{{ monthData.norbertproductivity.vacation }}</td>
                          <td>
                            {{ monthData.norbertproductivity.realworking }}
                          </td>
                          <td>
                            <div class="qn_add">
                              <v-icon
                                :disabled="
                                  monthData.norbertproductivity.sick == 0
                                "
                                @click="decrease(monthData.norbertproductivity)"
                                >mdi-minus</v-icon
                              >
                              <p>{{ monthData.norbertproductivity.sick }}</p>
                              <v-icon
                                :disabled="
                                  monthData.norbertproductivity.vacation == 0
                                "
                                @click="increase(monthData.norbertproductivity)"
                                >mdi-plus</v-icon
                              >
                            </div>
                          </td>
                          <td>
                            {{
                              monthData.norbertproductivity.prepostpreparation
                            }}
                          </td>
                          <td>{{ monthData.norbertproductivity.training }}</td>
                          <td>
                            {{ monthData.norbertproductivity.furthertraining }}
                          </td>
                          <td>
                            {{
                              monthData.norbertproductivity.traininginitiative
                            }}
                          </td>
                          <td>
                            {{ monthData.norbertproductivity.traveltime }}
                          </td>
                          <td>{{ monthData.norbertproductivity.misc }}</td>
                          <td>
                            {{ monthData.norbertproductivity.productivity }}%
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="openChart">
              <div class="productivity-graph">
                <div>
                <h3 class="productivity-graph-head">
                  {{ $t("trainer_Productivity") }}
                  {{ yearTrainerProductivity }}
                </h3>
                <BarChartKB
                  :chart-labels="monthlabels"
                  :chart-datasets="trainerProductivityArray"
                  :chart-id="roomusagechartId"
                  :dataset-id-key="roomusagedatasetIdKey"
                  :plugins="roomusageplugins"
                  :css-classes="roomusagecssClasses"
                  :styles="roomusagestyles"
                  :width="roomusagewidth"
                  :height="roomusageheight"
                  :chartOptions="chartOptionsTrainerProductivityAll"
                />
              </div>
                <div v-for="monthIndex in 12" :key="monthIndex">
                  <h3 class="productivity-graph-head">
                    {{ months[monthIndex - 1].name }} {{ $t("productivity") }}
                  </h3>
                  <div>
                    <BarChartKB
                      :chart-labels="trainerproductivitylabels"
                      :chart-datasets="
                        trainerproductivitydatasets[monthIndex - 1]
                      "
                      :chart-id="'trainerProductivityChart-' + monthIndex"
                      :dataset-id-key="trainerproductivitydatasetIdKey"
                      :plugins="trainerproductivityplugins"
                      :css-classes="trainerproductivitycssClasses"
                      :styles="trainerproductivitystyles"
                      :width="trainerproductivitywidth"
                      :height="trainerproductivityheight"
                      :chartOptions="chartOptionsTrainerProductivity"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="saleslist_header row m-0 revenue-saleslist-header">
              <div class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1">
                <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                  <v-autocomplete
                    v-model="yearFilterRoom"
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    :items="yearsListRoom"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    :label="$t('select_year')"
                    @change="changeYearRoom()"
                  >
                    <template v-slot:append></template>
                  </v-autocomplete>
                </div>
                <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                  <v-autocomplete
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('filter_by_country')"
                    v-model="RoomUsageCountry"
                    :items="sortedCountriesRoom"
                    @change="fetchRooms()"
                  >
                    <template v-slot:append></template>
                  </v-autocomplete>
                </div>
              </div>
              <!-- <div class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1">
                <div class="col-md-12 pull-right pt-0 pr-2" v-show="$rights.includes('VIEW_ROOM_FORECAST')">
                  <v-btn
                    :to="`/list-room-forecast`"
                    outlined
                    depressed
                    tile
                    class="savebutton m-0 float-right"
                    
                    >{{ $t("create_room_forecast") }}</v-btn
                  >
                </div>
              </div> -->
            </div>
            <div class="saleslist_body room-usage-section-wrapper">
              <div v-if="rooms.length > 0">
                <b-tabs content-class="">
                  <b-tab
                    v-for="room in rooms"
                    @click="getRoomData(room.id)"
                    :key="room.id"
                    :active="room.active"
                    class="pl-2"
                  >
                    <template class="room-usage-border-wrap" #title>
                      <h3 class="room-usage-h3">
                        {{ room.name }} {{ $t("room_usage_for_year") }}
                        {{ yearFilterRoom }}
                      </h3>
                    </template>
                    <b-tab class="border-room" title="|" disabled></b-tab>
                    <div class="tab_inner_body">
                      <div class="col-md-12 room-usage-wrap">
                        <b-table
                          responsive
                          striped
                          hover
                          :items="itemsRoom"
                        ></b-table>
                      </div>
                      <BarChartKB
                        :chart-labels="roomusagelabels"
                        :chart-datasets="roomusagedatasets"
                        :chart-id="roomusagechartId"
                        :dataset-id-key="roomusagedatasetIdKey"
                        :plugins="roomusageplugins"
                        :css-classes="roomusagecssClasses"
                        :styles="roomusagestyles"
                        :width="roomusagewidth"
                        :height="roomusageheight"
                        :chartOptions="chartOptionsRoomUsage"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <div v-else>
                <div class="nrf">{{ $t("no_room_found") }}</div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="saleslist_header row m-0 revenue-saleslist-header">
              <div class="col-md-12 col-xl-6 d-flex g-space-15 revanue_wrap1">
                <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                  <v-autocomplete
                    v-model="yearFilter"
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    :items="yearsList"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    :label="$t('select_year')"
                    @change="changeYear()"
                  >
                    <template v-slot:append></template>
                  </v-autocomplete>
                </div>
                <div class="col-md-12 col-xl-3 p-0 revanue_sy">
                  <v-autocomplete
                    v-model="monthFilter"
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    :items="months"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    :label="$t('select_month')"
                    @change="changeMonth()"
                  >
                    <template v-slot:append></template>
                  </v-autocomplete>
                </div>
                <div class="col-md-12 col-xl-5 p-0 revanue_sy position__top">
                  <div v-if="feedback">
                    {{ $t("number_of") }}
                    <span
                      ><b>{{ feedback.totalFeedBackCount }}</b></span
                    >
                    {{ $t("feedback_forms") }}
                  </div>
                </div>
              </div>
              <div
                class="col-md-12 col-xl-6 g-space-15 revanue_wrap2 d-flex justify-content-end align-self-center actual-revenew-filter-wrapper"
                style=""
              >
                <div class="col-md-12 col-xl-3 p-0 revanue_fbc">
                  <v-autocomplete
                    hide-details="auto"
                    :items="sortedCountriesFeedBack"
                    class="datainput justify-content-end align-self-center pb-1 country-wrap-dropdown-1"
                    dense
                    outlined
                    :label="$t('country')"
                    v-model="feedbackcountry"
                    @change="changeCountry()"
                  ></v-autocomplete>
                </div>
                <!-- <div class="col-md-3 pb-2 pl-2 pr-2" style="padding-top: 5px"> -->
                <v-btn
                  @click="display('chart')"
                  v-show="
                    $rights.includes('VIEW_PERFORMANCE_BOARD') && !showCharts
                  "
                  outlined
                  depressed
                  tile
                  class="savebutton view-chart-btn fb_vc right_margin_0"
                  ><img
                    class="view-charts-img"
                    src="../assets/img/chart.svg"
                  />{{ $t("view_charts") }}</v-btn
                >
                <v-btn
                  @click="display('report')"
                  v-show="
                    $rights.includes('VIEW_PERFORMANCE_BOARD') && showCharts
                  "
                  outlined
                  depressed
                  tile
                  class="savebutton view-chart-btn fb_vc right_margin_0"
                  ><img src="/static/img/report.svg" />{{
                    $t("view_reports")
                  }}</v-btn
                >
                <!-- </div> -->
              </div>
            </div>
            <div class="saleslist_body" v-if="showCharts">
              <div class="sl_list">
                <div class="col-xl-12 col-md-12 pa-0">
                  <div
                    class="border mb-5 border-dark border-5 trends-wrapper trends-wrapper-1"
                  >
                    <b>{{ $t("trends_by_the_months") }}</b>
                    <!-- <LineChartKB
                      :chart-labels="trendbymonthlabels"
                      :chart-datasets="trendbymonthdatasets"
                    /> -->
                    <BarChartKB
                      :chart-labels="trendbymonthlabels"
                      :chart-datasets="trendbymonthdatasets"
                      :chart-id="trendbymonthchartId"
                      :dataset-id-key="trendbymonthdatasetIdKey"
                      :plugins="trendbymonthplugins"
                      :css-classes="trendbymonthcssClasses"
                      :styles="trendbymonthstyles"
                      :width="trendbymonthwidth"
                      :height="trendbymonthheight"
                      :chartOptions="chartOptionsFeedBackTrends"
                    />
                  </div>
                  <div
                    class="border mb-5 border-dark border-5 trends-wrapper trends-wrapper-1"
                  >
                    <b>{{ $t("trainingevents") }}</b>
                    <!-- <LineChartKB
                      :chart-labels="trendbymonthlabels"
                      :chart-datasets="trendbymonthdatasets"
                    /> -->
                    <BarChartKB
                      :chart-labels="monthlabelsEvents"
                      :chart-datasets="numberOfEvents"
                      :chart-id="trendbymonthchartId"
                      :dataset-id-key="trendbymonthdatasetIdKey"
                      :plugins="trendbymonthplugins"
                      :css-classes="trendbymonthcssClasses"
                      :styles="trendbymonthstyles"
                      :width="trendbymonthwidth"
                      :height="trendbymonthheight"
                      :chartOptions="chartOptions"
                    />
                  </div>

                  <div class="border mb-3 border-dark border-5 trends-wrapper">
                    <b
                      >{{ $t("evaluation_of_the_feedback_forms") }}
                      {{ monthsList[this.monthFilter + 1] }}
                      {{ yearFilter }}</b
                    >

                    <BarChartKB
                      :chart-labels="labelsevaluationfeedback"
                      :chart-datasets="datasetsevaluationfeedback"
                      :chart-id="trendbymonthchartId"
                      :dataset-id-key="trendbymonthdatasetIdKey"
                      :plugins="trendbymonthplugins"
                      :css-classes="trendbymonthcssClasses"
                      :styles="trendbymonthstyles"
                      :width="trendbymonthwidth"
                      :height="trendbymonthheight"
                      :chartOptions="chartOptionsFeedBackColor"
                    />
                  </div>
                  <div class="row average-wrapper">
                    <div class="border border-dark border-5 average-grade">
                      <b>{{ $t("average_grade_training_preparation") }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingpreparation"
                        :chart-datasets="datasetstrainingpreparationChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradetrainingpreparation
                        "
                      />
                    </div>
                    <div class="border border-dark border-5 average-grade">
                      <b>{{ $t("average_grade_training_delivery") }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingdelivery"
                        :chart-datasets="datasetstrainingdeliveryChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradetrainingdelivery
                        "
                      />
                    </div>
                    <div class="border border-dark border-5 average-grade">
                      <b>{{ $t("average_grade_training_room") }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingroom"
                        :chart-datasets="datasetstrainingroomChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradetrainingroom
                        "
                      />
                    </div>
                    <div class="border border-dark border-5 average-grade">
                      <b>{{ $t("average_grade_training_conclusion") }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingconclusion"
                        :chart-datasets="datasetstrainingconclusionChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradetrainingconclusion
                        "
                      />
                    </div>
                    <div
                      class="col-6 border border-dark border-5 average-grade"
                    >
                      <b>{{ $t("average_grade_training_structure") }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingstructure"
                        :chart-datasets="datasetstrainingstructureChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradetrainingstructure
                        "
                      />
                    </div>
                    <div
                      class="col-6 border border-dark border-5 average-grade"
                    >
                      <b>{{
                        $t("average_grade_of_each_individual_training")
                      }}</b>

                      <BarChartKB
                        :chart-labels="labelstrainingindividual"
                        :chart-datasets="datasetstrainingindividualChart"
                        :chart-id="trendbymonthchartId"
                        :dataset-id-key="trendbymonthdatasetIdKey"
                        :plugins="trendbymonthplugins"
                        :css-classes="trendbymonthcssClasses"
                        :styles="trendbymonthstyles"
                        :width="trendbymonthwidth"
                        :height="trendbymonthheight"
                        :chartOptions="
                          chartOptionsFeedBackaveragegradeindividualtraining
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="saleslist_body feedback-tables-wrap test"
              v-if="feedback && !showCharts"
            >
              <h3 class="mt-0 p-3 mb-0 feedback-title">
                {{ $t("feedback_summary") }}
              </h3>
              <div
                class="saleslist_body"
                v-if="feedback && feedback.totalFeedBackCount > 0"
              >
                <div>
                  <div class="tab_inner_body">
                    <b-table
                      striped
                      responsive
                      hover
                      class="fe_table summary-table"
                      :items="convertedFeedback"
                      :fields="lasttableFields"
                    >
                      <template #thead-top="">
                        <b-tr class="main-row-wrapper">
                          <b-th
                            class="table-col-1 feedback-row-1"
                            colspan="2"
                            variant="secondary"
                            >{{ $t("preparation") }}
                            {{
                              datasetstrainingpreparation[0].data[
                                extraParameter
                              ]
                            }}</b-th
                          >
                          <b-th
                            class="table-col-2 feedback-row-2"
                            colspan="4"
                            variant="primary"
                            >{{ $t("training_room") }}
                            {{
                              datasetstrainingroom[0].data[extraParameter]
                            }}</b-th
                          >
                          <b-th
                            class="table-col-3 feedback-row-3"
                            colspan="3"
                            variant="danger"
                            >{{ $t("training_structure") }}
                            {{
                              datasetstrainingstructure[0].data[extraParameter]
                            }}</b-th
                          >
                          <b-th
                            class="table-col-4 feedback-row-4"
                            colspan="3"
                            variant="primary"
                          >
                            {{ $t("training_implementation") }}
                            {{
                              datasetstrainingdelivery[0].data[extraParameter]
                            }}</b-th
                          >
                          <b-th
                            class="table-col-5 feedback-row-5"
                            colspan="4"
                            variant="danger"
                            >{{ $t("trainer") }}
                            {{
                              datasetstrainingindividual[0].data[extraParameter]
                            }}</b-th
                          >
                          <b-th
                            class="table-col-6 feedback-row-6"
                            colspan="3"
                            variant="secondary"
                            >{{ $t("conclusion") }}
                            {{
                              datasetstrainingconclusion[0].data[extraParameter]
                            }}</b-th
                          >
                          <b-th
                            class="feedback-row-7"
                            colspan="1"
                            variant="secondary"
                          >
                          </b-th>
                        </b-tr>
                        <!-- {{ incrementExtraParameter() }} -->
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="nrf">{{ $t("no_feed_back_form") }}</div>
              </div>
              <div
                v-for="(
                  trainingFeedBack, i, extraParameter
                ) in feedback.trainingWiseFeedBackList"
                :key="i"
              >
                <b-card class="feedback-tables-wrap-2">
                  <b-card-header
                    header-tag="header"
                    class="p-3 card-head-main-dropdown"
                    @click="toggleAccordion(extraParameter)"
                  >
                    <h3 class="feedback-title-1">
                      <v-icon class="dropdown-icon-feedback">{{
                        getAccordionIcon(extraParameter)
                      }}</v-icon>
                      <i
                        aria-hidden="true"
                        class="v-icon notranslate mdi mdi-menu-down theme--light dropdown-icon-feedback-1"
                      ></i>
                      {{ i }}
                    </h3>
                  </b-card-header>
                  <b-collapse
                    v-model="accordionStates[extraParameter]"
                    class="collase-table-wrap"
                  >
                    <b-card-body class="tab_inner_body Feedback-inner-body">
                      <b-table
                        striped
                        responsive
                        hover
                        class="fe_table fe-margin feedback-main-row"
                        :items="trainingFeedBack"
                        :fields="tableFields"
                      >
                        <template #thead-top="">
                          <b-tr class="main-row-wrapper">
                            <b-th
                              class="table-col-1 feedback-row-1"
                              colspan="2"
                              variant="secondary"
                              >{{ $t("preparation") }}
                              {{
                                datasetstrainingpreparation[0].data[
                                  extraParameter
                                ]
                              }}</b-th
                            >
                            <b-th
                              class="table-col-2 feedback-row-2"
                              colspan="4"
                              variant="primary"
                              >{{ $t("training_room") }}
                              {{
                                datasetstrainingroom[0].data[extraParameter]
                              }}</b-th
                            >
                            <b-th
                              class="table-col-3 feedback-row-3"
                              colspan="3"
                              variant="danger"
                              >{{ $t("training_structure") }}
                              {{
                                datasetstrainingstructure[0].data[
                                  extraParameter
                                ]
                              }}</b-th
                            >
                            <b-th
                              class="table-col-4 feedback-row-4"
                              colspan="3"
                              variant="primary"
                            >
                              {{ $t("training_implementation") }}
                              {{
                                datasetstrainingdelivery[0].data[extraParameter]
                              }}</b-th
                            >
                            <b-th
                              class="table-col-5 feedback-row-5"
                              colspan="4"
                              variant="danger"
                              >{{ $t("trainer") }}
                              {{
                                datasetstrainingindividual[0].data[
                                  extraParameter
                                ]
                              }}</b-th
                            >
                            <b-th
                              class="table-col-6 feedback-row-6"
                              colspan="3"
                              variant="secondary"
                              >{{ $t("conclusion") }}
                              {{
                                datasetstrainingconclusion[0].data[
                                  extraParameter
                                ]
                              }}</b-th
                            >
                            <b-th
                              class="feedback-row-7"
                              colspan="1"
                              variant="secondary"
                            >
                            </b-th>
                          </b-tr>
                          <!-- {{ incrementExtraParameter() }} -->
                        </template>
                      </b-table>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  props: {
    yearTP: Number,
    monthTP: Number,
  },
  data() {
    return {
      trainerproductivity: null,
      revenueactualtarget: [
        {
          data: null,
        },
        {
          data: null,
        },
      ],
      revenueactualtargetTotal: [
        {
          data: null,
        },
        {
          data: null,
        },
      ],
      requestComparisonlabels: [],
      countriesRoom: [],
      numberOfEvents: [
        {
          data: null,
        },
      ],
      countriesFeedBack: [],
      RoomUsageCountry: "All",
      accordionStates: {},
      countries: [],
      feedbackcountry: "All",
      yearsOpenTransactions: [
        2023, 2024, 2025, 2026, 2026, 2027, 2028, 2029, 2030,
      ],
      yearOpenTrasactionsstart: new Date().getFullYear(),
      monthOpenTrasactionsstart: 0,
      yearOpenTrasactionsend: new Date().getFullYear(),
      monthOpenTrasactionsend: new Date().getMonth(),
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },

      chartOptionsTrainerProductivity: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 25,
              callback: function (value) {
                return value + "%";
              },
            },
          },
        },
      },
      chartOptions3p: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //  min: 0,
            //  max: 400000.00,
            suggestedMax: 10000.0,
            ticks: {
              //   stepSize: 50000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsIC: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //   min: 0,
            // max: 80000.00,
            suggestedMax: 10000.0,
            ticks: {
              //    stepSize: 10000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsOE: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //   min: 0,
            //    max: 80000.00,
            suggestedMax: 10000.0,
            ticks: {
              //    stepSize: 10000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsIV: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //  min: 0,
            //  max: 120000.00,
            suggestedMax: 10000.0,
            ticks: {
              //   stepSize: 20000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsMainline: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //  min: 0,
            //  max: 300000.00,
            suggestedMax: 10000.0,
            ticks: {
              //    stepSize: 50000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsRSGI: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //     min: 0,
            //   max: 300000.00,
            suggestedMax: 10000.0,
            ticks: {
              //       stepSize: 50000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsDB: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //    min: 0,
            //     max: 45000.00,
            suggestedMax: 10000.0,
            ticks: {
              //     stepSize: 5000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsUrban: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //   min: 0,
            suggestedMax: 10000.0,
            ticks: {
              //     stepSize: 5000,
              callback: function (value) {
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw;
                let formattedInteger = new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(value);

                return formattedInteger + " €";
              },
            },
          },
        },
      },
      chartOptionsTrainerProductivityAll: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 100,
            suggestedMax: 100.0,
            ticks: {
              stepSize: 25,
              callback: function (value) {
                return value + "%";
              },
            },
          },
        },
      },
      chartOptionsTotalOperation: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                // Only show integer values (hides decimal ticks)
                return Number.isInteger(value) ? value : null;
              },
            },
          },
        },
      },

      chartOptionsCurrent: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                // Only show integer values (hides decimal ticks)
                return Number.isInteger(value) ? value : null;
              },
            },
          },
        },
      },
      chartOptionsComparision: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                // Only show integer values (hides decimal ticks)
                return Number.isInteger(value) ? value : null;
              },
            },
          },
        },
      },
      chartOptionsByCustomer: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                // Only show integer values (hides decimal ticks)
                return Number.isInteger(value) ? value : null;
              },
            },
          },
        },
      },
      // chartOptionsFeedBackColor: {
      //   responsive: true,
      //   maintainAspectRatio: false,
      //   scales: {
      //     y: {
      //       min: 0,
      //       max: 6, // Set y-axis limit to 6
      //       ticks: {
      //         stepSize: 1, // Optional: set step size for better readability
      //       },
      //     },
      //   },
      //   plugins: {
      //     legend: {
      //       labels: {
      //         generateLabels(chart) {
      //           return [
      //             {
      //               text: "(<=2.0)",
      //               fillStyle: "green",
      //               hidden: false,
      //             },
      //             {
      //               text: "(2.0 - 3.0)",
      //               fillStyle: "#3f7ab6",
      //               hidden: false,
      //             },
      //             {
      //               text: "(>3.0)",
      //               fillStyle: "red",
      //               hidden: false,
      //             },
      //           ];
      //         },
      //       },
      //     },
      //   },
      // },
      chartOptionsFeedBack: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6, // Set y-axis limit to 6
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
      },
      actualrevenue3Pdatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenueICdatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenueOEdatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenueIVdatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenuersgidatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenuemainlinedatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenuedbdatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      actualrevenueurbandatasets: [
        {
          data: null,
        },
        // {
        //   data:null,
        // }
      ],
      trainerProductivityArray: [
        {
          data: null,
        },
      ],

      actualChart: false,
      actualcountry: "All",
      opencountry: "All",
      openChart: false,
      country: null,
      countryList: [],
      itemsActualTable: [],
      itemsOpenTable: [],
      extraParameter: 0,
      trendbymonthchartId: "custom-chart-id",
      trendbymonthdatasetIdKey: "label",
      trendbymonthplugins: [],
      trendbymonthcssClasses: "custom-chart-classes",
      trendbymonthstyles: {},
      trendbymonthwidth: 500,
      trendbymonthheight: 300,
      trendbymonthlabels: null,
      // trendbymonthdatasets: [
      //   // {
      //   //   data: null,
      //   // },
      // ],
      // datasetsevaluationfeedback: [
      //   {
      //     data: null,
      //   },
      // ],
      labelstrainingpreparation: null,
      datasetstrainingpreparation: [
        {
          data: null,
        },
      ],
      labelstrainingdelivery: null,
      datasetstrainingdelivery: [
        {
          data: null,
        },
      ],
      labelstrainingroom: null,
      datasetstrainingroom: [
        {
          data: null,
        },
      ],
      labelstrainingconclusion: null,
      datasetstrainingconclusion: [
        {
          data: null,
        },
      ],
      labelstrainingstructure: null,
      datasetstrainingstructure: [
        {
          data: null,
        },
      ],
      labelstrainingindividual: null,
      datasetstrainingindividual: [
        {
          data: null,
        },
      ],
      keysToIgnore: ["avgPreparation"],
      yearCount: null,
      yearCountRevenue: null,
      monthCount: null,
      monthFilter: new Date().getMonth(),
      yearFilter: new Date().getFullYear().toString(),
      yearFilterRevenue: new Date().getFullYear().toString(),
      categoryTab: null, // only data for select boxes
      RoomUsage: null,
      traningData: [],
      data3p: null,
      roomusagechartId: "custom-chart-id",
      roomusagedatasetIdKey: "label",
      roomusageplugins: [],
      roomusagecssClasses: "custom-chart-classes custom-chart-classes-1",
      roomusagestyles: {},
      roomusagewidth: 500,
      roomusageheight: 300,
      roomusagedatasets: [],
      currentTrainingOperationsdatasets: [
        {
          data: null,
        },
      ],
      requestComparisondatasets: [
        {
          data: null,
        },
      ],
      classificationByCustomerlabels: ["3P", "IC", "OE", "IV"],
      classificationByCustomerdatasets: [
        {
          data: null,
        },
      ],
      changeInTotalOperationsdatasets: [
        {
          data: null,
        },
        {
          data: null,
        },
      ],
      trainerproductivitychartId: "custom-chart-id",
      trainerproductivitydatasetIdKey: "label",
      trainerproductivityplugins: [],
      trainerproductivitycssClasses:
        "custom-chart-classes custom-chart-classes-1",
      trainerproductivitystyles: {},
      trainerproductivitywidth: 500,
      trainerproductivityheight: 300,
      trainerproductivitylabels: [],

      trainerproductivitydatasets: [],

      feedback: null,
      showCharts: false,
      rooms: [],
      yearFilterRoom: new Date().getFullYear(),
      yearsListRoom: [2024, 2025, 2026, 2026, 2027, 2028, 2029, 2030],
      room_id: null,

      itemsRoom: [],
      yearTrainerProductivity: new Date().getFullYear(),
      monthTrainerProductivity: new Date().getMonth(),
      zr_data: [],
      zrg_data: [],
      zr_data_table: [],
      zrg_data_table: [],
      cities: [],
      over_all_values: [],
      Grand_total: 0,
      istabrevenuedropdown: 1,
      numberOfEventsdata: [],
      datasetsevaluationfeedbackNew: [],
      datasetstrainingpreparationNew: [],
      datasetstrainingdeliveryNew: [],
      datasetstrainingroomNew: [],
      datasetstrainingconclusionNew: [],
      datasetstrainingstructureNew: [],
      datasetstrainingindividualNew: [],
    };
  },
  computed: {
    chartOptionsFeedBackTrends() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text: this.$t("feedback_forms") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text: this.$t("feedback_forms") + " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text: this.$t("feedback_forms") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    tooltipMessages() {
      return [
        this.$t("received_tooltip"),
        this.$t("satisfied_tooltip"),
        this.$t("place_tooltip"),
        this.$t("room_met_tooltip"),
        this.$t("break_time_tooltip"),
        this.$t("classroom_tooltip"),
        this.$t("training1_tooltip"),
        this.$t("share_of_tooltip"),
        this.$t("method_of_tooltip"),
        this.$t("learningpath_tooltip"),
        this.$t("training2_tooltip"),
        this.$t("learned_tooltip"),
        this.$t("trainer_name_tooltip"),
        this.$t("trainer_tooltip"),
        this.$t("content_tooltip"),
        this.$t("learning_process_tooltip"),
        this.$t("use_for_tooltip"),
        this.$t("recommend_knorr_tooltip"),
        this.$t("recommend_training_tooltip"),
      ];
    },

    chartOptionsRoomUsage() {
      return {
        responsive: true,

        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 25, // Set y-axis limit to 6
            ticks: {
              stepSize: 5, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
        },
      };
    },

    chartOptionsFeedBackColor() {
      return {
        responsive: true,

        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6, // Set y-axis limit to 6
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
          tooltip: {
            callbacks: {
              title: (tooltipItems) => {
                const index = tooltipItems[0].dataIndex;
                return this.tooltipMessages[index];
              },
            },
          },
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text:
                    this.$t("evaluation_of_the_feedback_forms") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("evaluation_of_the_feedback_forms") +
                    " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text: this.$t("evaluation_of_the_feedback_forms") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    chartOptionsFeedBackaveragegradetrainingpreparation() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text:
                    this.$t("average_grade_training_preparation") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_preparation") +
                    " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_preparation") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    chartOptionsFeedBackaveragegradetrainingdelivery() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text: this.$t("average_grade_training_delivery") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_delivery") + " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text: this.$t("average_grade_training_delivery") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },

    chartOptionsFeedBackaveragegradetrainingroom() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text: this.$t("average_grade_training_room") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text: this.$t("average_grade_training_room") + " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text: this.$t("average_grade_training_room") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    chartOptionsFeedBackaveragegradetrainingconclusion() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text:
                    this.$t("average_grade_training_conclusion") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_conclusion") +
                    " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_conclusion") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    chartOptionsFeedBackaveragegradetrainingstructure() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text:
                    this.$t("average_grade_training_structure") + " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_training_structure") +
                    " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text: this.$t("average_grade_training_structure") + " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    chartOptionsFeedBackaveragegradeindividualtraining() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1, // Optional: set step size for better readability
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              generateLabels: (chart) => [
                {
                  text:
                    this.$t("average_grade_of_each_individual_training") +
                    " (<=2.0)", // Using i18n
                  fillStyle: "green",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_of_each_individual_training") +
                    " (2.0 - 3.0)", // Using i18n
                  fillStyle: "#3f7ab6",
                  hidden: false,
                },
                {
                  text:
                    this.$t("average_grade_of_each_individual_training") +
                    " (>3.0)", // Using i18n
                  fillStyle: "red",
                  hidden: false,
                },
              ],
            },
          },
        },
      };
    },
    trendbymonthdatasets() {
      return [
        {
          label: this.$t("feedback_forms"),
          data: this.trendbymonthdatasetsNew || [],
          backgroundColor: (this.trendbymonthdatasetsNew || []).map((value) =>
            value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },

    datasetsevaluationfeedback() {
      console.log("Recomputing dataset...");
      return [
        {
          label: this.$t("evaluation_of_the_feedback_forms"),
          data: this.datasetsevaluationfeedbackNew || [],
          backgroundColor: (this.datasetsevaluationfeedbackNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingpreparationChart() {
      return [
        {
          label: this.$t("average_grade_training_preparation"),
          data: this.datasetstrainingpreparationNew || [],
          backgroundColor: (this.datasetstrainingpreparationNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingdeliveryChart() {
      return [
        {
          label: this.$t("average_grade_training_delivery"),
          data: this.datasetstrainingdeliveryNew || [],
          backgroundColor: (this.datasetstrainingdeliveryNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingroomChart() {
      return [
        {
          label: this.$t("average_grade_training_room"),
          data: this.datasetstrainingroomNew || [],
          backgroundColor: (this.datasetstrainingroomNew || []).map((value) =>
            value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingconclusionChart() {
      return [
        {
          label: this.$t("average_grade_training_conclusion"),
          data: this.datasetstrainingconclusionNew || [],
          backgroundColor: (this.datasetstrainingconclusionNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingstructureChart() {
      return [
        {
          label: this.$t("average_grade_training_structure"),
          data: this.datasetstrainingstructureNew || [],
          backgroundColor: (this.datasetstrainingstructureNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    datasetstrainingindividualChart() {
      return [
        {
          label: this.$t("average_grade_of_each_individual_training"),
          data: this.datasetstrainingindividualNew || [],
          backgroundColor: (this.datasetstrainingindividualNew || []).map(
            (value) =>
              value <= 2.0 ? "green" : value > 3.0 ? "red" : "#3f7ab6"
          ),
        },
      ];
    },
    chartOptionsTotalrevenue() {
      const countrySettings = {
        GERMANY: { min: 0, max: 500000.0, stepSize: 100000 },
        FRANCE: { min: 0, max: 40000.0, stepSize: 5000.0 },
        AUSTRIA: { min: 0, max: 100000.0, stepSize: 10000.0 },
        HUNGARY: { min: 0, max: 16000.0, stepSize: 2000.0 },
        ITALY: { min: 0, max: 60000.0, stepSize: 10000.0 },
        KAZAKHSTAN: { min: 0, max: 16000.0, stepSize: 2000.0 },
        NORDIC: { min: 0, max: 16000.0, stepSize: 2000.0 },
        POLAND: { min: 0, max: 70000.0, stepSize: 10000.0 },
        SPAIN: { min: 0, max: 100000.0, stepSize: 10000.0 },
        SWITZERLAND: { min: 0, max: 35000.0, stepSize: 5000.0 },
        UNITED_KINGDOM: { min: 0, max: 16000.0, stepSize: 2000.0 },
        All: { min: 0, max: 500000.0, stepSize: 100000 },
      };
      const defaultSettings = { min: 0, max: 500000.0, stepSize: 100000 };
      const { min, max, stepSize } =
        countrySettings[this.actualcountry] || defaultSettings;

      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //min,
            // max,
            suggestedMax: 10000.0,
            ticks: {
              //  stepSize: stepSize, // Dynamically adjust step size
              callback: function (value) {
                return (
                  new Intl.NumberFormat("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(value) + " €"
                );
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                return (
                  new Intl.NumberFormat("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(context.raw) + " €"
                );
              },
            },
          },
        },
      };
    },
    chartOptionsTotalactualrevenue() {
      const countrySettings = {
        GERMANY: { min: 0, max: 2500000.0, stepSize: 500000 },
        FRANCE: { min: 0, max: 120000.0, stepSize: 20000.0 },
        AUSTRIA: { min: 0, max: 450000.0, stepSize: 50000.0 },
        HUNGARY: { min: 0, max: 45000.0, stepSize: 5000.0 },
        ITALY: { min: 0, max: 90000.0, stepSize: 10000.0 },
        KAZAKHSTAN: { min: 0, max: 45000.0, stepSize: 5000.0 },
        NORDIC: { min: 0, max: 120000.0, stepSize: 20000.0 },
        POLAND: { min: 0, max: 250000.0, stepSize: 50000.0 },
        SPAIN: { min: 0, max: 350000.0, stepSize: 50000.0 },
        SWITZERLAND: { min: 0, max: 140000.0, stepSize: 20000.0 },
        UNITED_KINGDOM: { min: 0, max: 45000.0, stepSize: 5000.0 },
        All: { min: 0, max: 2500000.0, stepSize: 500000.0 },
      };
      const defaultSettings = { min: 0, max: 2500000.0, stepSize: 500000.0 };
      const { min, max, stepSize } =
        countrySettings[this.actualcountry] || defaultSettings;

      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            //  min,
            //  max,
            suggestedMax: 10000.0,
            ticks: {
              //  stepSize: stepSize, // Dynamically adjust step size
              callback: function (value) {
                return (
                  new Intl.NumberFormat("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(value) + " €"
                );
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                return (
                  new Intl.NumberFormat("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(context.raw) + " €"
                );
              },
            },
          },
        },
      };
    },
    monthlabelsEvents() {
      var monthlabelsEvents1 = [];
      for (let index = 0; index < this.numberOfEventsdata.length; index++) {
        //console.log(this.numberOfEventsdata.length)
        monthlabelsEvents1[index] =
          this.monthsRoom[index] +
          " (" +
          this.numberOfEventsdata[index] +
          " " +
          this.$t("trainingevents") +
          ")";
      }
      //  console.log(monthlabelsEvents1)
      return monthlabelsEvents1;
    },
    itemsOpen() {
      if (this.opencountry == "GERMANY" || this.opencountry == "All") {
        return [
          { key: "title", label: this.$t("processing-status2") },
          { key: "p", label: "3P" },
          { key: "ic", label: "IC" },
          { key: "oe", label: "OE" },
          { key: "iv", label: "IV" },
          { key: "total", label: this.$t("total") },
        ];
      } else {
        return [
          { key: "title", label: this.$t("processing-status2") },
          { key: "p", label: "3P" },
          { key: "ic", label: "IC" },
          { key: "oe", label: "OE" },
          { key: "iv", label: "IV" },
          { key: "total", label: this.$t("total") },
        ];
      }
    },
    itemsActual() {
      if (this.actualcountry == "GERMANY" || this.actualcountry == "All") {
        return [
          { key: "month", label: this.$t("monthP") },
          { key: "index", label: "" },
          { key: "mainline", label: "MAINLINE" },
          { key: "db", label: "DB" },
          { key: "urban", label: "URBAN" },
          { key: "rsgi", label: "RSGI" },
          { key: "p", label: "3P" },
          { key: "ic", label: "IC" },
          { key: "pic", label: "3P+IC" },
          { key: "oe", label: "OE" },
          { key: "lv", label: "IV" },
          { key: "oeiv", label: "OE+IV" },
          { key: "total", label: this.$t("total") },
        ];
      } else {
        return [
          { key: "month", label: this.$t("monthP") },
          { key: "index", label: "" },
          { key: "p", label: "3P" },
          { key: "ic", label: "IC" },
          { key: "oe", label: "OE" },
          { key: "lv", label: "IV" },
          { key: "oeiv", label: "OE+IV" },
          { key: "total", label: this.$t("total") },
        ];
      }
    },
    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },

    sortedCountriesFeedBack() {
      return this.countriesFeedBack
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    sortedCountriesRoom() {
      return this.countriesRoom
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },

    yearsList() {
      return [
        this.$t("select_year"),
        "2024",
        "2025",
        "2026",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ];
    },
    months() {
      return [
        { id: 0, name: this.$t("january") },
        { id: 1, name: this.$t("february") },
        { id: 2, name: this.$t("march") },
        { id: 3, name: this.$t("april") },
        { id: 4, name: this.$t("may") },
        { id: 5, name: this.$t("june") },
        { id: 6, name: this.$t("july") },
        { id: 7, name: this.$t("august") },
        { id: 8, name: this.$t("september") },
        { id: 9, name: this.$t("october") },
        { id: 10, name: this.$t("november") },
        { id: 11, name: this.$t("december") },
      ];
    },
    monthsRoom() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },

    changeInTotalOperationslabels() {
      return [
        //this.$t("operation"),
        this.$t("open"),
        this.$t("in_progress"),
        this.$t("quotation"),
        this.$t("order_received"),
        this.$t("on_hold"),
        this.$t("invoicing"),
        this.$t("invoice_created"),
      ];
    },
    currentTrainingOperationslabels() {
      return [
        // this.$t("operation"),
        this.$t("open"),
        this.$t("in_progress"),
        this.$t("offer_sent"),
        this.$t("quotation"),
        this.$t("order_received"),
        this.$t("on_hold"),
        this.$t("invoicing"),
        this.$t("open_training"),
        this.$t("invoice_created"),
      ];
    },
    roomusagelabels() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },

    tableFields() {
      return [
        {
          key: "receivedInvitation",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "received_tooltip"
          )}">${this.$t("received")}</span>`,
        },
        {
          key: "satisfiedWithPreparation",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "satisfied_tooltip"
          )}">${this.$t("statisfied")}</span>`,
        },
        {
          key: "placeSuitableForTraining",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "place_tooltip"
          )}">${this.$t("place")}</span>`,
        },
        {
          key: "roomMetExpectations",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "room_met_tooltip"
          )}">${this.$t("room_met")}</span>`,
        },
        {
          key: "breakTime",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "break_time_tooltip"
          )}">${this.$t("break_time")}</span>`,
        },
        {
          key: "classroomCleanliness",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "classroom_tooltip"
          )}">${this.$t("classroom")}</span>`,
        },
        {
          key: "trainingDocumentsUnderstandable",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "training1_tooltip"
          )}">${this.$t("training1")}</span>`,
        },
        {
          key: "shareOfTheoryPractice",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "share_of_tooltip"
          )}">${this.$t("share_of")}</span>`,
        },
        {
          key: "methodsOfLearning",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "method_of_tooltip"
          )}">${this.$t("methods_of")}</span>`,
        },
        {
          key: "learningSpeed",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learningpath_tooltip"
          )}">${this.$t("learning")}</span>`,
        },
        {
          key: "trainingContribution",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "training2_tooltip"
          )}">${this.$t("training_feedback")}</span>`,
        },
        {
          key: "learnedNewThings",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learned_tooltip"
          )}">${this.$t("learned")}</span>`,
        },
        {
          key: "trainerswellprepared",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "trainer_name_tooltip"
          )}">${this.$t("trainers")}</span>`,
        },
        {
          key: "trainerTechnicallyCompetent",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "trainer_tooltip"
          )}">${this.$t("trainer_feedback")}</span>`,
        },
        {
          key: "contentExplainedWell",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "content_tooltip"
          )}">${this.$t("content")}</span>`,
        },
        {
          key: "learningProcessWellOrganized",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learning_process_tooltip"
          )}">${this.$t("learning_process")}</span>`,
        },
        {
          key: "useforEverydayWork",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "use_for_tooltip"
          )}">${this.$t("use_for")}</span>`,
        },
        {
          key: "recommendationProvider",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "recommend_knorr_tooltip"
          )}">${this.$t("recommend_knorr")}</span>`,
        },
        {
          key: "recommendationTraining",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "recommend_training_tooltip"
          )}">${this.$t("recommend_training")}</span>`,
        },
        { key: "avgGrade", label: this.$t("average_grade") },
      ];
    },

    lasttableFields() {
      return [
        {
          key: "avgReceivedInvitation",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "received_tooltip"
          )}">${this.$t("received")}</span>`,
        },
        {
          key: "avgSatisfiedPreparation",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "satisfied_tooltip"
          )}">${this.$t("statisfied")}</span>`,
        },
        {
          key: "avgSuitableRoom",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "place_tooltip"
          )}">${this.$t("place")}</span>`,
        },
        {
          key: "avgExpectedTrainingRoom",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "room_met_tooltip"
          )}">${this.$t("room_met")}</span>`,
        },
        {
          key: "avgBreakTimes",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "break_time_tooltip"
          )}">${this.$t("break_time")}</span>`,
        },
        {
          key: "avgCleanTrainingRoom",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "classroom_tooltip"
          )}">${this.$t("classroom")}</span>`,
        },
        {
          key: "avgEasyTrainingMaterial",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "training1_tooltip"
          )}">${this.$t("training1")}</span>`,
        },
        {
          key: "avgTheoryPractice",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "share_of_tooltip"
          )}">${this.$t("share_of")}</span>`,
        },
        {
          key: "avgSupportedLearningProcess",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "method_of_tooltip"
          )}">${this.$t("methods_of")}</span>`,
        },
        {
          key: "avgLearningSpeed",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learningpath_tooltip"
          )}">${this.$t("learning")}</span>`,
        },
        {
          key: "avgInvolvedTraining",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "training2_tooltip"
          )}">${this.$t("training_feedback")}</span>`,
        },
        {
          key: "avgNewThings",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learned_tooltip"
          )}">${this.$t("learned")}</span>`,
        },
        {
          key: "avgTrainerwellprepared",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "trainer_name_tooltip"
          )}">${this.$t("trainers")}</span>`,
        },
        {
          key: "avgTrainerprofessional",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "trainer_tooltip"
          )}">${this.$t("trainer_feedback")}</span>`,
        },
        {
          key: "avgTrainerexplained",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "content_tooltip"
          )}">${this.$t("content")}</span>`,
        },
        {
          key: "avgTrainerorganized",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "learning_process_tooltip"
          )}">${this.$t("learning_process")}</span>`,
        },
        {
          key: "avgBenefitseveryday",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "use_for_tooltip"
          )}">${this.$t("use_for")}</span>`,
        },
        {
          key: "avgRecommendknorr",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "recommend_knorr_tooltip"
          )}">${this.$t("recommend_knorr")}</span>`,
        },
        {
          key: "avgRecommendTraining",
          labelHtml: `<span v-b-tooltip.hover title="${this.$t(
            "recommend_training_tooltip"
          )}">${this.$t("recommend_training")}</span>`,
        },
        { key: "avgGradeTraining", label: this.$t("average_grade") },
      ];
    },
    monthsList() {
      return [
        this.$t("select_month"),
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },

    monthlabels() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },
    labelsevaluationfeedback() {
      return [
        this.$t("received"),
        this.$t("statisfied"),
        this.$t("place"),
        this.$t("room_met"),
        this.$t("break_time"),
        this.$t("classroom"),
        this.$t("training1"),
        this.$t("share_of"),
        this.$t("methods_of"),
        this.$t("learning"),
        this.$t("training_feedback"),
        this.$t("learned"),
        this.$t("trainers"),
        this.$t("trainer_feedback"),
        this.$t("content"),
        this.$t("learning_process"),
        this.$t("use_for"),
        this.$t("recommend_knorr"),
        this.$t("recommend_training"),
      ];
    },

    convertedFeedback() {
      const combinedObject = {};
      for (const key in this.feedback) {
        if (
          Object.hasOwnProperty.call(this.feedback, key) &&
          !Array.isArray(this.feedback[key]) && // Exclude if it's an array
          typeof this.feedback[key] !== "object" // Exclude if it's an object
        ) {
          combinedObject[key] = this.feedback[key];
        }
      }
      const convertedArray = [combinedObject];
      return convertedArray;
    },
    monthTrainerProductivity_data() {
      // Access the reactive data properties directly using `this`
      return this.monthsRoom[this.monthTrainerProductivity];
    },
  },
  methods: {
    validateAndFormatAmount(input) {
      if (!input) return "";

      // Fix US-style formats if detected
      input = input.toString();
      input = this.correctInputFormat(input);

      // If already German-style, just append ,00 if needed
      const germanFormatRegex = /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/;
      if (germanFormatRegex.test(input)) {
        return input.includes(",") ? input : `${input},00`;
      }

      // Standard number formatting
      let number = parseFloat(input.replace(/\./g, "").replace(",", "."));
      if (isNaN(number)) return input;

      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
    correctInputFormat(input) {
      // If input is US-style (digits with a dot before 2 decimals), convert it
      const usStyleRegex = /^\d+(\.\d{1,2})?$/;
      if (usStyleRegex.test(input)) {
        return input.replace(/\./, ",");
      }

      // If input is US-style with thousand separators (e.g. 1,234.98)
      const usThousandStyleRegex = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/;
      if (usThousandStyleRegex.test(input)) {
        return input.replace(/,/g, "").replace(/\./, ",");
      }

      return input; // Return as-is if no match
    },
    increase(trainer) {
      if (trainer.sick < trainer.sick + trainer.vacation) {
        trainer.sick++;
        trainer.vacation--;
        //  console.log(trainer.userId)
        this.updateSickData(trainer);
      }
    },
    decrease(trainer) {
      if (trainer.sick > 0) {
        trainer.sick--;
        trainer.vacation++;
        this.updateSickData(trainer);
      }
    },
    updateSickData(trainerData) {
      this.$axios
        .post("/api/trainer-productivity/update-sick-data", trainerData)
        .then(function (response) {
          // console.log(response)
        })
        .catch(this.onError);
    },

    changeCountrytrainerProductivity() {
      this.getTrainerProductivity();
    },
    getMonthName(month) {
      const months = [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
      return months[month - 1];
    },
    toggleAccordion(index) {
      this.$set(this.accordionStates, index, !this.accordionStates[index]);
    },
    getAccordionIcon(index) {
      return this.accordionStates[index]
        ? "mdi-chevron-up"
        : "mdi-chevron-down";
    },

    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countriesRoom = JSON.parse(JSON.stringify(response.data));
          this.countriesRoom.unshift("All");
          this.countries = JSON.parse(JSON.stringify(response.data));
          this.countries.unshift("All");
          this.countriesFeedBack = JSON.parse(JSON.stringify(response.data));
          this.countriesFeedBack.unshift("All");
          this.countriesFeedBack.unshift("virtual");
        })
        .catch(this.onError);
    },

    getOpenTransactions() {
      var _this = this;
      if (
        this.yearOpenTrasactionsstart !== null &&
        this.monthOpenTrasactionsstart !== null &&
        this.yearOpenTrasactionsend !== null &&
        this.monthOpenTrasactionsend !== null
      ) {
        this.monthCountStart = this.monthOpenTrasactionsstart + 1;
        this.monthCountEnd = this.monthOpenTrasactionsend + 1;

        this.$axios
          .get("/api/performanceboard/opentransactions", {
            params: {
              startmonth: _this.monthCountStart,
              startyear: _this.yearOpenTrasactionsstart,
              endmonth: _this.monthCountEnd,
              endyear: _this.yearOpenTrasactionsend,
              country: _this.opencountry,
            },
          })
          .then(function (response) {
            _this.currentTrainingOperationsdatasets[0].data =
              response.data.currentTrainingOperations;
            _this.requestComparisonlabels = response.data.monthYearList;
            _this.requestComparisondatasets[0].data =
              response.data.requestComparison;
            _this.classificationByCustomerdatasets[0].data =
              response.data.classificationOfCustomers;
            _this.changeInTotalOperationsdatasets[0].data =
              response.data.changeInTotalOperations1;
            _this.changeInTotalOperationsdatasets[1].data =
              response.data.changeInTotalOperations2;
            _this.itemsOpenTable = response.data.transactionTable;
          })
          .catch(this.onError);
      }
    },
    changeOpenChart() {
      this.openChart = !this.openChart;
    },
    changeRevenueChart() {
      this.actualChart = !this.actualChart;
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    changeYearRevenue() {
      if (this.yearFilterRevenue) {
        this.yearCountRevenue =
          this.yearsList[this.yearsList.indexOf(this.yearFilterRevenue)];
        this.fetchRevenue();
        this.fetchRevenueTotal();
      }
    },
    changeYear() {
      this.fetchFeedBackPerformance();
      this.fetchFeedBackPerformanceAvg();
      this.fetchNumberOfEvents();
    },
    changeCountry() {
      this.fetchFeedBackPerformance();
      this.fetchFeedBackPerformanceAvg();
    },
    changeActualCountry() {
      this.fetchRevenue();
      this.fetchRevenueTotal();
    },
    changeOpenCountry() {
      this.getOpenTransactions();
    },
    changeMonth() {
      this.fetchFeedBackPerformance();
      this.fetchFeedBackPerformanceAvg();
    },
    incrementExtraParameter() {
      this.extraParameter++;
    },
    display(param) {
      if (param === "chart") {
        this.showCharts = true;
      } else {
        this.showCharts = false;
      }
    },
    formatValue(value) {
      return value === 0 ? `€ ${this.formatToEuropeanAmount(value)}` : value;
    },
    formatToEuropeanAmount(input) {
      try {
        let cleanedInput = input
          .toString()
          .trim()
          .replace(/€/g, "")
          .replace(/,/g, "")
          .replace(/;/g, "");
        let number = parseFloat(cleanedInput);
        if (isNaN(number)) {
          // console.log("Invalid input: not a number");
        }
        return new Intl.NumberFormat("de-DE").format(number);
      } catch (error) {
        console.error(error.message);
        return null;
      }
    },
    fetchRevenue() {
      var _this = this;
      if (_this.yearCountRevenue !== null) {
        this.$axios
          .get("/api/performanceboard/revenue", {
            params: {
              year: _this.yearCountRevenue,
              country: _this.actualcountry,
            },
          })
          .then(function (response) {
            _this.itemsActualTable = response.data.actualRevenue;
          })
          .catch(this.onError);
      }
    },

    fetchRevenueTotal() {
      var _this = this;
      if (_this.yearCountRevenue !== null) {
        this.$axios
          .get("/api/performanceboard/revenue-total", {
            params: {
              year: _this.yearCountRevenue,
              country: _this.actualcountry,
            },
          })
          .then(function (response) {
            // _this.itemsActualTable = response.data.actualRevenue;
            // _this.actualrevenue3Pdatasets[0].data = response.data.target3p;
            _this.actualrevenue3Pdatasets[0].data = response.data.actual3p;
            //  _this.actualrevenueICdatasets[0].data = response.data.targetIC;
            _this.actualrevenueICdatasets[0].data = response.data.actualIC;
            // _this.actualrevenueOEdatasets[0].data = response.data.targetOE;
            _this.actualrevenueOEdatasets[0].data = response.data.actualOE;
            //_this.actualrevenueIVdatasets[0].data = response.data.targetIV;
            _this.actualrevenueIVdatasets[0].data = response.data.actualIV;
            //   _this.actualrevenuersgidatasets[0].data = response.data.targetrsgi;
            _this.actualrevenuersgidatasets[0].data = response.data.actualrsgi;
            //_this.actualrevenuemainlinedatasets[0].data =   response.data.targetmainline;
            _this.actualrevenuemainlinedatasets[0].data =
              response.data.actualmainline;
            //  _this.actualrevenuedbdatasets[0].data = response.data.targetdb;
            _this.actualrevenuedbdatasets[0].data = response.data.actualdb;
            //  _this.actualrevenueurbandatasets[0].data =  response.data.targeturban;
            _this.actualrevenueurbandatasets[0].data =
              response.data.actualurban;
            _this.revenueactualtarget[0].data = response.data.targetValue;
            _this.revenueactualtarget[1].data = response.data.actualValue;

            _this.revenueactualtargetTotal[0].data =
              response.data.targetValueTotal;
            _this.revenueactualtargetTotal[1].data =
              response.data.actualValueTotal;
          })
          .catch(this.onError);
      }
    },

    fetchFeedBackPerformance() {
      var _this = this;
      this.yearCount = this.yearsList[this.yearsList.indexOf(this.yearFilter)];
      this.monthCount = this.monthFilter;
      this.country =
        this.countryList[this.countryList.indexOf(this.yearFilter)];
      if (_this.yearCount !== null && _this.monthCount !== null) {
        this.$axios
          .get("/api/performanceboard/feedback", {
            params: {
              year: _this.yearCount,
              month: _this.monthCount + 1,
              country: _this.feedbackcountry,
            },
          })
          .then(function (response) {
            _this.feedback = response.data;
            _this.labelstrainingdelivery = response.data.labelstrainingdelivery;
            _this.labelstrainingpreparation =
              response.data.labelstrainingpreparation;
            _this.labelstrainingroom = response.data.labelstrainingroom;
            _this.labelstrainingdelivery = response.data.labelstrainingdelivery;
            _this.labelstrainingconclusion =
              response.data.labelstrainingconclusion;
            _this.labelstrainingstructure =
              response.data.labelstrainingstructure;
            _this.labelstrainingindividual =
              response.data.labelstrainingindividual;
            _this.trendbymonthlabels = response.data.trendbymonthlabels;

            _this.datasetstrainingpreparation[0].data =
              response.data.datasetstrainingpreparation;
            _this.datasetstrainingdelivery[0].data =
              response.data.datasetstrainingdelivery;
            _this.datasetstrainingroom[0].data =
              response.data.datasetstrainingroom;
            _this.datasetstrainingconclusion[0].data =
              response.data.datasetstrainingconclusion;
            _this.datasetstrainingstructure[0].data =
              response.data.datasetstrainingstructure;
            _this.datasetstrainingindividual[0].data =
              response.data.datasetstrainingindividual;

            _this.datasetstrainingpreparationNew =
              response.data.datasetstrainingpreparation;
            _this.datasetstrainingdeliveryNew =
              response.data.datasetstrainingdelivery;
            _this.datasetstrainingroomNew = response.data.datasetstrainingroom;
            _this.datasetstrainingconclusionNew =
              response.data.datasetstrainingconclusion;
            _this.datasetstrainingstructureNew =
              response.data.datasetstrainingstructure;
            _this.datasetstrainingindividualNew =
              response.data.datasetstrainingindividual;
            _this.datasetsevaluationfeedbackNew =
              response.data.datasetsevaluationfeedback;
            // _this.trendbymonthdatasets[0].data =
            //   response.data.trendbymonthdatasets;

            // _this.trendbymonthdatasetsNew = response.data.trendbymonthdatasets;

            _this.$forceUpdate();
          })
          .catch(this.onError);
      }
    },

    fetchFeedBackPerformanceAvg() {
      var _this = this;
      this.yearCount = this.yearsList[this.yearsList.indexOf(this.yearFilter)];
      this.monthCount = this.monthFilter;
      this.country =
        this.countryList[this.countryList.indexOf(this.yearFilter)];
      if (_this.yearCount !== null && _this.monthCount !== null) {
        this.$axios
          .get("/api/performanceboard/feedback-avg-grade", {
            params: {
              year: _this.yearCount,
              month: _this.monthCount + 1,
              country: _this.feedbackcountry,
            },
          })
          .then(function (response) {
            // _this.trendbymonthdatasets[0].data =
            //   response.data.trendbymonthdatasets;

            _this.trendbymonthdatasetsNew = response.data.trendbymonthdatasets;

            _this.$forceUpdate();
          })
          .catch(this.onError);
      }
    },

    fetchNumberOfEvents() {
      var _this = this;
      this.yearCount = this.yearsList[this.yearsList.indexOf(this.yearFilter)];
      if (_this.yearCount !== null && _this.monthCount !== null) {
        this.$axios
          .get("/api/performanceboard/number-of-events", {
            params: {
              year: _this.yearCount,
            },
          })
          .then(function (response) {
            _this.numberOfEventsdata = response.data;
            _this.numberOfEvents[0].data = response.data;
            _this.$forceUpdate();
          })
          .catch(this.onError);
      }
    },

    fetchRooms() {
      var _this = this;
      _this.rooms = [];
      this.$axios
        .get("/api/performanceboard/room-data/" + this.RoomUsageCountry)
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            _this.rooms.push({
              id: response.data[i]["id"],
              name: response.data[i]["designation"],
              active: false,
            });
          }
          if (response.data.length > 0) {
            _this.getRoomData(response.data[0].id);
          }
          //console.log(_this.rooms)
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    getRoomData(room_id) {
      var _this = this;
      this.room_id = room_id;
      this.$axios
        .get(
          "/api/performanceboard/room-data-per-year/" +
            _this.room_id +
            "/" +
            _this.yearFilterRoom
        )
        .then(function (response) {
          var actual_usage = [];
          var forecast_usage = [];
          _this.itemsRoom = [];
          for (var i = 0; i < response.data.length; i++) {
            actual_usage.push(response.data[i]["actual_usage"]);
            forecast_usage.push(response.data[i]["forecast_usage"]);
            var month = _this.$t("month");
            var _OF_WORKING_DAYS_IN_MONTH = _this.$t(
              "NO._OF_WORKING_DAYS_IN_MONTH"
            );
            var NO_OF_DAYS_OF_SPACE_UTILIZATION = _this.$t(
              "NO._OF_DAYS_OF_SPACE_UTILIZATION"
            );
            var SPACE_UTILIZATION_IN_ = _this.$t("SPACE_UTILIZATION_IN_%");
            var FORECAST_IN_ = _this.$t("FORECAST_IN_%");
            var TARGET_IN_ = _this.$t("TARGET_IN_%");
            _this.itemsRoom.push({
              [month]: _this.monthsRoom[response.data[i]["month"] - 1],
              [_OF_WORKING_DAYS_IN_MONTH]:
                response.data[i]["number_of_working_days_in_month"],
              [NO_OF_DAYS_OF_SPACE_UTILIZATION]:
                response.data[i]["actual_usage"],
              [SPACE_UTILIZATION_IN_]:
                response.data[i]["percentage_actual_utilization"] + "%",
              // FORECAST: response.data[i]["forecast_usage"],
              // [FORECAST_IN_]:
              //   response.data[i]["percentage_forecast_utilization"] + "%",
              [TARGET_IN_]: response.data[i]["target_percentage"] + "%",
            });
          }

          _this.roomusagedatasets = [
            {
              label:
                _this.$t("Number_of_days_of_space_utilization") +
                " " +
                response.data[0]["room"]["designation"],
              backgroundColor: "#3f7ab6",
              data: actual_usage,
            },
            // {
            //   label: _this.$t("forecast"),
            //   backgroundColor: "#e1eafa",
            //   data: forecast_usage,
            // },
          ];
        })
        .catch(this.onError);
    },
    changeYearRoom() {
      if (this.room_id != null) {
        this.getRoomData(this.room_id);
      }
    },

    async getTrainerProductivity() {
      try {
        // Make the API request
        const response = await this.$axios.get(
          "/api/trainer-productivity/trainer/" +
            this.yearTrainerProductivity +
            "/" +
            this.feedbackcountry
        );

        // Assign the data to trainerproductivity
        this.trainerproductivity = response.data;
        let arrayData = [];
        for (let index = 0; index < this.trainerproductivity.length; index++) {
          arrayData.push(this.trainerproductivity[index].totalProductive);
        }
        this.trainerProductivityArray[0].data = arrayData;
        // Prepare the bar chart data
        this.prepareBarChartData();
      } catch (error) {
        // Handle any errors from the API call
        this.onError(error);
      }
    },
    prepareBarChartData() {
      // Initialize an object to hold trainer data by trainer name
      const trainers = {};

      // Iterate through the response data to accumulate monthly productivity for each trainer
      this.trainerproductivity.forEach((monthData) => {
        monthData.trainerProductivity.forEach((trainer) => {
          if (!trainers[trainer.trainername]) {
            trainers[trainer.trainername] = new Array(12).fill(0); // Initialize array for each month
          }

          const monthIndex = monthData.month - 1; // Adjust for zero-based index
          trainers[trainer.trainername][monthIndex] =
            this.calculateProductivityPercentage(trainer);
        });
      });

      // Prepare the datasets for each month
      this.trainerproductivitylabels = Object.keys(trainers);

      for (let i = 0; i < 12; i++) {
        this.trainerproductivitydatasets[i] = [
          {
            data: [],
            label: this.$t("productivity"),
            backgroundColor: "#3f7ab6",
          },
        ];
        this.trainerproductivitylabels.forEach((trainername) => {
          this.trainerproductivitydatasets[i][0].data.push(
            trainers[trainername][i]
          );
        });
        // console.log( this.trainerproductivitydatasets[i]);
      }
    },

    // Method to calculate the productivity percentage for a trainer
    calculateProductivityPercentage(trainer) {
      const totalPossibleProductiveTime =
        trainer.prepostpreparation + trainer.training + trainer.misc;

      const actualProductiveTime = trainer.realworking;

      // Calculate and return the productivity percentage
      return (totalPossibleProductiveTime / actualProductiveTime) * 100;
    },
    istabrevenue(value) {
      this.istabrevenuedropdown = value;
    },
    getMonthNameById(monthId) {
      const month = this.months.find((m) => m.id === monthId);
      return month ? month.name : this.$t("no_month_selected");
    },
  },
  mounted() {
    this.fetchCountries();
    this.fetchRooms();

    if (this.$route.query.yearTP != null && this.$route.query.monthTP != null) {
      this.categoryTab = 1;
      this.yearTrainerProductivity = parseInt(this.$route.query.yearTP);
      this.monthTrainerProductivity = parseInt(this.$route.query.monthTP);
    }
    
    this.getTrainerProductivity();
    this.changeYearRevenue();
    this.getOpenTransactions();
    this.fetchFeedBackPerformance();
    this.fetchFeedBackPerformanceAvg();
    this.fetchNumberOfEvents();
  },
  updated() {
    if (this.revenueactualtarget && this.revenueactualtarget.length > 0) {
      // Update the first item (target)

      this.revenueactualtarget[0].label = this.$t("target-value");
      this.revenueactualtarget[0].backgroundColor = "#9cb0bf";

      // Update the second item (actual)

      this.revenueactualtarget[1].label = this.$t("actual-value");
      this.revenueactualtarget[1].backgroundColor = "#3f7ab6";
    }

    if (this.revenueactualtargetTotal && this.revenueactualtarget.length > 0) {
      // Update the first item (target)
      //this.revenueactualtargetTotal[0].hidden = true;
      this.revenueactualtargetTotal[0].label = this.$t("target-value");
      this.revenueactualtargetTotal[0].backgroundColor = "#9cb0bf";

      // Update the second item (actual)

      this.revenueactualtargetTotal[1].label = this.$t("actual-value");
      this.revenueactualtargetTotal[1].backgroundColor = "#3f7ab6";
    }

    if (
      this.actualrevenue3Pdatasets &&
      this.actualrevenue3Pdatasets.length > 0
    ) {
      // this.actualrevenue3Pdatasets[0].hidden = true;
      // this.actualrevenue3Pdatasets[0].label = this.$t("actual_target_3p");
      // this.actualrevenue3Pdatasets[0].backgroundColor = "#9cb0bf";

      this.actualrevenue3Pdatasets[0].label = this.$t("actual_revenue_3p");
      this.actualrevenue3Pdatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.actualrevenueICdatasets &&
      this.actualrevenueICdatasets.length > 0
    ) {
      // this.actualrevenueICdatasets[0].hidden = true;
      // this.actualrevenueICdatasets[0].label = this.$t("actual_target_IC");
      // this.actualrevenueICdatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenueICdatasets[0].label = this.$t("actual_revenue_IC");
      this.actualrevenueICdatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.actualrevenueOEdatasets &&
      this.actualrevenueOEdatasets.length > 0
    ) {
      // this.actualrevenueOEdatasets[0].hidden = true;
      // this.actualrevenueOEdatasets[0].label = this.$t("actual_target_OE");
      // this.actualrevenueOEdatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenueOEdatasets[0].label = this.$t("actual_revenue_OE");
      this.actualrevenueOEdatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.actualrevenueIVdatasets &&
      this.actualrevenueIVdatasets.length > 0
    ) {
      //  this.actualrevenueIVdatasets[0].hidden = true;
      // this.actualrevenueIVdatasets[0].label = this.$t("actual_target_IV");
      // this.actualrevenueIVdatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenueIVdatasets[0].label = this.$t("actual_revenue_IV");
      this.actualrevenueIVdatasets[0].backgroundColor = "#3f7ab6";
    }
    if (
      this.actualrevenuersgidatasets &&
      this.actualrevenuersgidatasets.length > 0
    ) {
      // this.actualrevenuersgidatasets[0].hidden = true; // Hide target bars
      // this.actualrevenuersgidatasets[0].label = this.$t(
      //   "actual_target_rsgi"
      // );
      // this.actualrevenuersgidatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenuersgidatasets[0].backgroundColor = "#3f7ab6";
      this.actualrevenuersgidatasets[0].label = this.$t("actual_revenue_rsgi");
    }
    if (
      this.actualrevenuemainlinedatasets &&
      this.actualrevenuemainlinedatasets.length > 0
    ) {
      //   this.actualrevenuemainlinedatasets[0].hidden = true;
      // this.actualrevenuemainlinedatasets[0].label = this.$t(
      //   "actual_target_mainline"
      // );
      // this.actualrevenuemainlinedatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenuemainlinedatasets[0].backgroundColor = "#3f7ab6";
      this.actualrevenuemainlinedatasets[0].label = this.$t(
        "actual_revenue_mainline"
      );
    }
    if (
      this.actualrevenuedbdatasets &&
      this.actualrevenuedbdatasets.length > 0
    ) {
      //   this.actualrevenuedbdatasets[0].hidden = true;
      // this.actualrevenuedbdatasets[0].label = this.$t("actual_target_db");
      // this.actualrevenuedbdatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenuedbdatasets[0].label = this.$t("actual_revenue_db");
      this.actualrevenuedbdatasets[0].backgroundColor = "#3f7ab6";
    }
    if (
      this.actualrevenueurbandatasets &&
      this.actualrevenueurbandatasets.length > 0
    ) {
      //  this.actualrevenueurbandatasets[0].hidden = true;
      // this.actualrevenueurbandatasets[0].label = this.$t(
      //   "actual_target_urban"
      // );
      // this.actualrevenueurbandatasets[0].backgroundColor = "#9cb0bf";
      this.actualrevenueurbandatasets[0].label = this.$t(
        "actual_revenue_urban"
      );
      this.actualrevenueurbandatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.trainerProductivityArray &&
      this.trainerProductivityArray.length > 0
    ) {
      this.trainerProductivityArray[0].label = this.$t("trainer_productivity");
      this.trainerProductivityArray[0].backgroundColor = "#3f7ab6";
    }

    // if (this.trendbymonthdatasets && this.trendbymonthdatasets.length > 0) {
    //   this.trendbymonthdatasets[0].label = this.$t("feedback_forms");
    //   this.trendbymonthdatasets[0].backgroundColor = "#3f7ab6";
    // }
    if (this.numberOfEvents && this.numberOfEvents.length > 0) {
      this.numberOfEvents[0].label = this.$t("trainingevents");
      this.numberOfEvents[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.currentTrainingOperationsdatasets &&
      this.currentTrainingOperationsdatasets.length > 0
    ) {
      this.currentTrainingOperationsdatasets[0].label = this.$t(
        "current_training_operation"
      );
      this.currentTrainingOperationsdatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.requestComparisondatasets &&
      this.requestComparisondatasets.length > 0
    ) {
      this.requestComparisondatasets[0].label = this.$t("request_comparison");
      this.requestComparisondatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.classificationByCustomerdatasets &&
      this.classificationByCustomerdatasets.length > 0
    ) {
      this.classificationByCustomerdatasets[0].label = this.$t(
        "classification_by_customers"
      );
      this.classificationByCustomerdatasets[0].backgroundColor = "#3f7ab6";
    }

    if (
      this.changeInTotalOperationsdatasets &&
      this.changeInTotalOperationsdatasets.length > 0
    ) {
      this.changeInTotalOperationsdatasets[0].label =
        this.$t("start _year&month");
      this.changeInTotalOperationsdatasets[0].backgroundColor = "#3f7ab6";
      this.changeInTotalOperationsdatasets[1].label = this.$t("end_year&month");
      this.changeInTotalOperationsdatasets[1].backgroundColor = "#9cb0bf";
    }

    // if (this.changeInTotalOperationsdatasets && this.changeInTotalOperationsdatasets.length > 0) {
    //   }
  },
};
</script>
